import api from './api-v1';

// Create new feuille data
export const createFeuilleData = async (data) => {
    try {
        const response = await api.post('/feuille_data', data);
        return response.data;	
    } catch (error) {
        console.error('Error creating feuille data:', error);
        throw error;
    }
};

// Update feuille data
export const updateFeuilleData = async (id, data) => {
    try {
        const response = await api.put(`/feuille_data/${id}`, data);
        return response.data;	
    } catch (error) {
        console.error('Error updating feuille data:', error);
        throw error;
    }
};

// Delete feuille data
export const deleteFeuilleData = async (data) => {
    try {
        const response = await api.post(`/feuille_data/deletes`, data);
        return response.data;
    } catch (error) {
        console.error('Error deleting feuille data:', error);
        throw error;
    }
};

// Validate feuille data
export const validateFeuilleData = async (data) => {
    try {
        const response = await api.post(`/feuille_data/validations`, data);
        return response.data;	
    } catch (error) {
        console.error('Error validating feuille data:', error);
        throw error;
    }
};

// Get feuille data
export const getFeuilleData = async (feuilleId) => {
    try {
        const response = await api.get(`/feuille_data/${feuilleId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching feuille data:', error);
        throw error;
    }
};